module.exports = __webpack_public_path__ + "media/img/figma-7e7e08bfd7cb4e6b478928c828fb2ff4.jpg";